import { SexoPorExtenso } from 'src/tipos'

export const SELECT_SEXO = Object.keys(SexoPorExtenso).map(item => ({
  id: item,
  texto: SexoPorExtenso[item as keyof typeof SexoPorExtenso]
}))
